module.exports = __webpack_public_path__ + "static/img/industry04.edaabfe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wap/industry04.png
// module id = s8lR
// module chunks = 0